export const getSentryDSN = () => process.env.REACT_APP_SENTRY_DSN;
export const isSentryActive = Boolean(getSentryDSN());
